export default {"src":"/_next/static/media/baseline-establishment.22d67af6.svg","height":288,"width":253,"blurWidth":0,"blurHeight":0};